import React, { Fragment } from 'react';
import classNames from 'classnames';
import AnchorLink from '@/components/TableOfContents/AnchorLink';
import { ImageType } from '@/utils/common.types';

interface ICardProps {
  styles: string;
  info: {
    image: ImageType;
    slug: string;
    tag: string;
    headline: string;
  };
  key: number;
}

const drawCard = ({ styles, info, key }: ICardProps) => {
  return (
    <Fragment key={key}>
      <a
        className={classNames(
          'relative mb-5 block min-h-[288px] rounded-[4px] bg-cover bg-no-repeat p-6 no-underline shadow-high md:w-full',
          styles
        )}
        style={{
          backgroundImage: `url(${info?.image?.url}?fm=webp)`,
        }}
        href={`https://www.claytonhomes.com/studio/${info?.slug}${
          info?.slug?.endsWith('/') ? '' : '/'
        }`}
        target="_blank"
        rel="noopener noreferrer"
        key={key}
      >
        <div className="absolute">
          <div className="font-source-sans text-[10px] font-bold uppercase tracking-[0.5px] text-white">
            {info?.tag}
          </div>
          <h3 className="w-[92%] font-acumin text-[25px] font-bold leading-[1.2] tracking-[-0.35px] text-white md:w-mobile lg:w-[93%]">
            {info?.headline}
          </h3>
        </div>
      </a>
    </Fragment>
  );
};

interface IImageGrid {
  title: string;
  content: {
    image: ImageType;
    slug: string;
    tag: string;
    headline: string;
  }[];
  anchorTagRef: string;
}

const ImageGrid = ({ title, content, anchorTagRef = '' }: IImageGrid) => {
  if (!content || content.length === 0) {
    return;
  }

  const getEntryStyles = (key: number) => {
    switch (key) {
      case 0:
        return 'md:col-start-1';
      case 2:
        return 'md:col-start-2 md:row-start-1 md:row-end-3';
      default:
        return '';
    }
  };

  return (
    <section className="scroll-m-standard">
      <AnchorLink anchorTagRef={anchorTagRef} />
      <section
        className="mx-auto w-mobile max-w-screen-compactTablet md:max-w-screen-lgDesktop"
        id={anchorTagRef && `anchortag-${anchorTagRef}`}
      >
        <h2
          className="mb-[30px] font-acumin text-[22px] font-bold leading-[26px] tracking-[-0.35px] text-grey-1 md:text-[25px] md:text-hbg-blue"
          data-testid="imagegrid-heading"
        >
          {title}
        </h2>
        <div className="grid grid-cols-1 pb-6 md:grid-cols-2 md:gap-x-4 lgDesktop:gap-x-6">
          {content?.map((info, key) =>
            drawCard({ styles: getEntryStyles(key), info, key })
          )}
        </div>
      </section>
    </section>
  );
};

export default ImageGrid;
